import { plotLayout } from '../../../core/components/chart-grid/ChartGrid.sty.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { Grid } from '../../../core/components/grid/Grid.js';
import { useGetVariants } from '../../hooks/useGetVariants.js';
import { useGetVisibleAxesScales } from '../../hooks/useGetVisibleAxesScales.js';

export const XYChartGridLayout = () => {
  const { width, height } = useGridPlotSize();

  const variants = useGetVariants();
  const visibleAxisScales = useGetVisibleAxesScales();

  if (!variants.isOnlyDotSeries()) {
    return null;
  }

  if (!visibleAxisScales.hasXAndYScale) {
    return null;
  }

  return (
    <svg className={plotLayout}>
      <Grid
        xScale={visibleAxisScales.xScale}
        yScale={visibleAxisScales.yScale}
        height={height}
        width={width}
        highlightZeroLine={{
          horizontal: false,
          vertical: false,
        }}
      />
    </svg>
  );
};

XYChartGridLayout['displayName'] = 'XYChartGridLayout';
